/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { DeletedWallets } from "./DeletedWallets";
import * as t from "io-ts";

// required attributes
const DeletedWalletsResponseR = t.interface({});

// optional attributes
const DeletedWalletsResponseO = t.partial({
  data: DeletedWallets
});

export const DeletedWalletsResponse = t.intersection(
  [DeletedWalletsResponseR, DeletedWalletsResponseO],
  "DeletedWalletsResponse"
);

export type DeletedWalletsResponse = t.TypeOf<typeof DeletedWalletsResponse>;
